export const toggleElementById = (
  id: number,
  selectedIds: number[],
  setSelectedIds: any,
  checked?: boolean
) => {
  if (checked !== undefined) {
    if (!checked) {
      const newArray = [...selectedIds, id]

      setSelectedIds(newArray)
    } else {
      const newArray = selectedIds.filter(item => item !== id)

      setSelectedIds(newArray)
    }
  } else if (selectedIds.includes(id)) {
    const newArray = selectedIds.filter(item => item !== id)

    setSelectedIds(newArray)
  } else {
    const newArray = [...selectedIds, id]

    setSelectedIds(newArray)
  }
}

export const toggleAllElementsById = (
  elements: any[],
  selectedIds: number[],
  setSelectedIds: any
) => {
  if (elements.length === selectedIds.length) {
    setSelectedIds([])
  } else {
    const newArray = elements.map((i, id) => id)

    setSelectedIds(newArray)
  }
}
